var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 12C18.578 12 20.6673 9.91064 20.6673 7.33331C20.6673 4.75598 18.578 2.66664 16.0007 2.66664C13.4233 2.66664 11.334 4.75598 11.334 7.33331C11.334 9.91064 13.4233 12 16.0007 12Z",
    stroke: "#548170",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 27.3333C2.66797 21.442 8.04064 16.6666 14.668 16.6666",
    stroke: "#548170",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.668 28.6666C25.9817 28.6666 28.668 25.9804 28.668 22.6666C28.668 19.3529 25.9817 16.6666 22.668 16.6666C19.3543 16.6666 16.668 19.3529 16.668 22.6666C16.668 25.9804 19.3543 28.6666 22.668 28.6666Z",
    stroke: "#548170",
    strokeWidth: 2.66667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.002 20.6666V23.3333H24.6686",
    stroke: "#548170",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointment_icon.69c7a496e634d8b46f2e58b5ba60051a.svg";
export { ForwardRef as ReactComponent };